// Тайминги и лимиты асинхронного поиска — как в SessionStatus.js / Search.js монолита.
export const SEARCH_STATUS_POLL_INTERVAL_MS = 3000;
export const SEARCH_STATUS_WAITING_TIME_MS = 60000;
export const SEARCH_MIDDLE_REQUEST_LIMIT = 500;
export const SEARCH_PRICE_RANGE = { from: 6000, to: 21000000 } as const;
